
<template>
  <div>
    <div
      v-if="!file && !processing"
      class="drop-zone"
      @dragover.prevent
      @drop.prevent
      @drop="handleDrop"
      @click="$refs.fileInput.click()"
    >
      <sn-btn
        class="mr-4"
        text="Select file"
        type="secondary"
        size="standard"
        prepend-icon="sn-icon-upload"
      />
      <span>or drop your file here</span>
      <input
        ref="fileInput"
        :accept="accept"
        name="fileInput"
        style="display: none"
        type="file"
        @change="handleInput"
      >
    </div>
    <div
      v-if="file && !processing"
      class="added-file"
    >
      <v-icon
        class="mx-4"
        style="cursor: pointer"
        @click="clearFile"
      >
        $snExitCircle
      </v-icon>
      <div class="ml-6 filename">
        {{ displayName }}
      </div>
      <sn-avatar
        class="ml-4"
        background-class="sn-background-brand-01"
        icon="$snDocument"
      />
    </div>
    <div
      v-if="processing"
      class="box"
    >
      <div style="width: 100%">
        <p>{{ displayName }}</p>
        <v-progress-linear
          indeterminate
          rounded
          class="sn-background-brand-03"
        />
      </div>
    </div>
  </div>
</template>

<script>

import snBtn from '~/components/snui/v2/snBtn/snBtn'
import snAvatar from '~/components/snui/v2/snAvatar/snAvatar'
export default {
  components: {
    snAvatar,
    snBtn
  },
  props: {
    accept: {
      type: String,
      required: false,
      default: undefined
    },
    processing: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data () {
    return {
      file: null
    }
  },
  computed: {
    displayName () {
      return this.file ? this.file.name : ''
    }
  },
  methods: {
    handleInput (event) {
      this.file = event.target.files[0]
      this.$emit('file', this.file)
    },
    handleDrop (event) {
      this.file = event.dataTransfer.files[0]
      if (this.accept && !this.accept.includes(this.file.type)) {
        this.file = null
      } else {
        this.$emit('file', this.file)
      }
    },
    clearFile () {
      this.file = null
      this.$emit('file', null)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~/assets/css/snui';

.box {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100px;
  justify-content: center;
  flex-direction: row-reverse;
  border-radius: 16px;
  box-sizing: border-box;
}

.drop-zone {
  @extend .box;
  cursor: pointer;
  transition: background 200ms;
  border: 2px dashed $sn-gray-04;

  &:hover {
    background: $sn-brand-01;
    transition: background 300ms;
  }
}

.added-file {
  @extend .box;
  border: 1px solid $sn-gray-04;
}

.filename {
  flex: 1;
  max-width: calc(100% - 136px);
}
</style>
